import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'

import Content from './Content'
import SecondContent from './SecondContent'
import Action from './Action'
import Portfolios from './Portfolios'
import PrevNextButton from './PrevNextButton'

import Styles from './index.scss'

const Detail = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    { props.errorMessage !== '' && (
      <div className={Styles.errorMessage}>
        {props.errorMessage}
      </div>
    ) }
    <PrevNextButton nextId={props.data.next} prevId={props.data.prev} />
    <div className="col-md-12 margin-bottom-40 margin-top-40">
      <div
        className={`col-md-3  ${Styles['about-header']}`}
        style={{
          backgroundImage: `url(${props.data.logo})`,
          width: '250px',
          height: '250px',
        }}
      />
      <div className="col-md-6">
        <Action data={props.data} />
      </div>
    </div>

    <div className="col-md-12 no-space margin-bottom-20">
      <h3 className={Styles.informationTitle}>Main Information</h3>
      <div className="col-md-12">
        <Content data={props.data} />
      </div>
    </div>
    <div className="col-md-12 no-space margin-bottom-40">
      <h3 className={Styles.informationTitle}>Secondary Information</h3>
      <div className="col-md-12">
        <SecondContent data={props.data} />
      </div>
    </div>
    <div className={`${Styles['about-text']} portlet light`}>
      <div className="portlet-body">
        <div className="table-scrollable table-scrollable-borderless">
          <table className="table table-hover table-light">
            <thead>
              <tr className="capitalize">
                <th> No. </th>
                <th> Status </th>
                <th> Date Added </th>
                <th> Title </th>
                <th> Topic </th>
                <th> Portfolio </th>
                <th className="table-actions"> Actions </th>
              </tr>
            </thead>
            {props.productPortfolios.rows.length > 0 && (
              <tbody>
                {props.productPortfolios.rows.map((row, key) => (
                  <Portfolios
                    portfolioStatus={props.portfolioStatus}
                    topic={props.topic}
                    indexKey={key}
                    key={row.id}
                    row={row}
                    skip={props.productPortfolios.qs.skip}
                  />
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  </div>
)
Detail.defaultProps = {
  productPortfolios: {},
  data: {
    logo: '',
    profile: {
      profileId: '',
      about: 'Lorem ipsum dolor sit amet',
    },
  },
  isLoading: false,
}

Detail.propTypes = {
  data: PropTypes.shape({
    logo: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      profileId: PropTypes.string.isRequired,
      about: PropTypes.string,
    }).isRequired,
    next: PropTypes.string,
    prev: PropTypes.string,
  }).isRequired,
  productPortfolios: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  errorMessage: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default Detail
